/* !
 * jQuery product v1.0.0
 * Copyright 2024, Connecty Inc.
 */
(function($, THERMOS){
	const map = THERMOS.va.isEnglish ? THERMOS.va.pathname.split('/')[3] : THERMOS.va.pathname.split('/')[2]; // list or series or detail
	const arrowPrev = '<button type="button" class="slick-prev"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';

	// シリーズ情報JSON
	const getJSONseries = (_seriesID) => {
		const jsonURL = THERMOS.va.isEnglish ? `/ajax/english/product/spec/${_seriesID}.json` : `/ajax/product/spec/${_seriesID}.json`;
		return $.getJSON(jsonURL);
	};
	// タグ取得JSON
	const getJSONseriesTags = (_seriesID) => {
		const jsonURL = THERMOS.va.isEnglish ? `/ajax/english/product/spec/tag/${_seriesID}.json` : `/ajax/product/spec/tag/${_seriesID}.json`
		return $.getJSON(jsonURL);
	};
	// カラー情報JSON
	const getJSONprodColor = (_pn) => {
		return $.getJSON(`/ajax/product/color/${_pn}.json`);
	};

	// URLにカラーのパラメータを付与する
	const colorExtract = (_color) => {
		if (_color.length > 1) {
			const extract = _color.replace(/[（）]/g, (s) => {
				return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
			});
			return extract.replace(/^.*\((.*)\)$/, '$1');
		} else {
			return '';
		}
	};
	const changeColor = () => {
		// サムネイルクリックでメイン画像切り替え
		$('.js-changeItem').on('click', (e) => {
			$('.js-changeItemMain').html($(e.currentTarget).html());
		})
		// 色指定パラメータありなら画像切り替え
		if (location.search) {
			let colorCode = location.search.replace(/\?color=/, '');
			$('.js-changeItem').each((idx, ele) => {
				if (colorExtract($(ele).find('.__colorName').text()) === colorCode) {
					$('.js-changeItemMain').html($(ele).html());
				}
			});
		}
	};

	// [製品トップ] カルーセル
	const topMainVis = () => {
		const arrowPath = 'M12,40.1c-1,0-2-.4-2.9-1.2-1.6-1.6-1.6-4.1,0-5.7l13.2-13.2L9.1,6.8c-1.6-1.6-1.6-4.1,0-5.7s4.1-1.6,5.7,0l16.1,16.1c1.6,1.6,1.6,4.1,0,5.7l-16.1,16.1c-.8.8-1.8,1.2-2.9,1.2h0Z';
		let splide_mv = new Splide('.prod-top-mainVis.splide', {
			type: 'loop',
			arrows: true,
			arrowPath: arrowPath,
			pagination: true,
			paginationKeyboard: true,
			speed: 1500,
			autoplay: true,
			interval: 5000,
			pauseOnHover: false,
			autoWidth: true,
			gap: '20px',
			focus: 'center',
			breakpoints: {
				640: {
					gap: '10px',
				},
			}
		});
		splide_mv.mount();
		// 一時停止中にプログレスアニメーションを停止する
		document.querySelector('.prod-top-mainVis.splide .splide__toggle').addEventListener('click', () => {
			document.querySelector('.prod-top-mainVis.splide .splide__pagination').classList.toggle('is-paused');
		});
	};
	// [製品トップ] PICKUP出力
	const setPickup = () => {
		const getJSONpickup = (_seriesID) => {
			return $.getJSON('/ajax/pick_up/article.json');
		};
		getJSONpickup().then((data) => {
			if (data.rt_bn_news_list.length) {
				let pickupHTML = '';

				// 1個目（1カラム）
				pickupHTML += `<li class="__column_1"><a href="${data.rt_bn_news_list[0].n_url}" class="__main mod-boxLink01">` +
					`<figure class="__column_2 __column_tab_1"><img src="${data.rt_bn_news_list[0].rt_cf_n_image_file_name.src}"`;
				if (data.rt_bn_news_list[0].rt_cf_n_image_file_name.alt) {
					pickupHTML += ` alt="${data.rt_bn_news_list[0].rt_cf_n_image_file_name.alt}"`;
				}
				if (data.rt_bn_news_list[0].rt_cf_n_image_file_name.title) {
					pickupHTML += ` title="${data.rt_bn_news_list[0].rt_cf_n_image_file_name.title}"`;
				}
				pickupHTML += `><figcaption>PICK UP ${data.rt_bn_news_list[0].n_remarks}</figcaption></figure>` +
					`<div class="__caption __column_2 __column_tab_1"><p class="__title">${data.rt_bn_news_list[0].n_title}</p><p class="__sub">${data.rt_bn_news_list[0].n_sub_title}</p>` +
					`</div></a></li>`;

				// 2～5個目（2カラム）
				let count = (data.rt_bn_news_list.length < 6) ? data.rt_bn_news_list.length : 5;
				for (let i = 1; i < count; i++) {
					pickupHTML += `<li class="__column_2 __column_tab_1"><a href="${data.rt_bn_news_list[i].n_url}" class="__sub mod-boxLink01">` +
						`<figure><img src="${data.rt_bn_news_list[i].rt_cf_n_image_file_name.src}"`;
					if (data.rt_bn_news_list[i].rt_cf_n_image_file_name.alt) {
						pickupHTML += ` alt="${data.rt_bn_news_list[i].rt_cf_n_image_file_name.alt}"`;
					}
					if (data.rt_bn_news_list[i].rt_cf_n_image_file_name.title) {
						pickupHTML += ` title="${data.rt_bn_news_list[i].rt_cf_n_image_file_name.title}"`;
					}
					pickupHTML += `><figcaption>PICK UP ${data.rt_bn_news_list[i].n_remarks}</figcaption></figure>` +
						`<div class="__caption">${data.rt_bn_news_list[i].n_title}</div></a></li>`;
				}

				$('.prod-top-pickup ul').append(pickupHTML);
			} else {
				$('.prod-top-pickup').remove();
			}
		});
	};

	// [一覧系] 空のタグ消込
	const removeEmptyTag = () => {
		document.querySelectorAll('.prod-series-list-item .cf_pse_tags').forEach(ele => { // サイズタグ・機能タグ
			if (!ele.innerText) {
				ele.remove();
			}
		});
		document.querySelectorAll('.prod-series-list-item .__size, .prod-series-list-item .__tags').forEach(ele => {
			if (!ele.querySelectorAll('li').length) {
				ele.remove();
			}
		});
	};
	// [一覧系] シリーズ製品品番整形
	const setSeriesProdNum = () => {
		$('.prod-series-list-item').each((idx, item) => {
			$(item).find('h3').html(`<span class="__name">${$(item).find('h3').text().split('/')[0]}</span><span class="__pn">${$(item).find('h3').text().split('/')[1]}</span>`);
		});
	};

	// [シリーズ一覧] カテゴリ回遊ナビ カレントは非表示
	const bottomNavCurrent = () => {
		document.querySelectorAll('.prod-series-bottomNav a').forEach(ele => {
			if (ele.getAttribute('href') === THERMOS.va.pathname) {
				ele.closest('li').classList.add('di_none');
			}
		});
	};

	// [シリーズ詳細共通]製品品番タブ 位置調整
	const tabCurrent = () => {
		$('.prod-detail-seriesLink').find('a').each((idx, ele) => {
			if ($(ele).attr('href') === THERMOS.va.pathname) {
				$(ele).addClass('is-active');

				// モバイル表示時、シリーズリンクのカレントの商品を左端に調整する
				if (THERMOS.va.window.width < THERMOS.va.device.desktop) {
					$('.prod-detail-seriesLink').scrollLeft($(ele).offset().left);
				}
			}
		});
	};
	// [シリーズ詳細01] 空のタグ消込
	const removeEmptyTagSeries = () => {
		$('.__tags .cf_pse_tags').each((idx, ele) => {
			if (!$(ele).text().length) {
				$(ele).remove();
			}
		});
	};
	// [シリーズ詳細01/02] 空のアイコン消込
	const removeEmptyIcon = () => {
		$('.prod-detail-iconList .cf_pse_tags').each((idx, ele) => {
			if (!$(ele).find('img').length) {
				$(ele).remove();
			}
		});
	};
	// [シリーズ詳細02] 製品品番タブ 親品番出力
	const setSeriesTab = () => {
		let thisID = $('.prod-detail-seriesLink .rt_cf_ps_series_id').text();
		getJSONseries(thisID).then((data) => {
			if (data.product_spec_list.length) {
				let seriesList = '';
				data.product_spec_list.forEach((ele, index) => {
					seriesList += `<li><a href="${ele.rt_cf_product_detail_href.href}">${ele.ps_product_number}</a></li>`;
				});
				$('.prod-detail-seriesLink').find('ul').append(seriesList);
				tabCurrent();
			}
		});
	};
	// [シリーズ詳細02] シリーズ詳細01と同じタグを表示
	const setSeriesTags = () => {
		let thisID = $('.prod-detail-seriesLink .rt_cf_ps_series_id').text();
		getJSONseriesTags(thisID).then((data) => {
			if (data.rt_bn_product_series_info[0].cf_pse_tags.length) {
				const tagList = data.rt_bn_product_series_info[0].cf_pse_tags;
				let tagHTML = '';
				tagList.forEach(ele => {
					if (ele._key.indexOf('d_') === 0) {
						tagHTML += (THERMOS.va.isEnglish) ? `<li><span>${ele.cf_st_name_d_en}</span></li>` : `<li><span>${ele.cf_st_name_d}</span></li>`;
					}
				});
				if (tagHTML) {
					$('.prod-detail-gallery .__tags').append(tagHTML);
				} else {
					$('.prod-detail-gallery .__tags').remove();
				}
			} else {
				$('.prod-detail-gallery .__tags').remove();
			}
		});
	};
	// [シリーズ詳細01] フライパンのみ：2つ目以降の仕様欄消し込み
	const removeFryingpanNote = () => {
		$('.prod-detail-note').each((idx, ele) => {
			if (idx !== 0) { $(ele).remove(); }
		});
	};

	// [シリーズ詳細01/03] 最近見た商品登録
	const setRecentlyItemStorage = () => {
		const viewDatetime = new Date();
		let year = viewDatetime.getFullYear();
		let month = viewDatetime.getMonth() + 1; month = ('0' + month).slice(-2);
		let date = viewDatetime.getDate(); date = ('0' + date).slice(-2);
		let hour = viewDatetime.getHours(); hour = ('0' + hour).slice(-2);
		let minute = viewDatetime.getMinutes(); minute = ('0' + minute).slice(-2);
		let second = viewDatetime.getSeconds(); second = ('0' + second).slice(-2);
		let key = THERMOS.va.isEnglish ? THERMOS.va.pathname.split('/')[4].replace(/\.html/, '') : THERMOS.va.pathname.split('/')[3].replace(/\.html/, '');

		localStorage.setItem(
			`thermosProdRecentView_${key}`,
			`${year}-${month}-${date} ${hour}:${minute}:${second}`
		);
	};

	// 最近見た商品出力
	const setRecentlyViewItem = () => {
		let recentStorage = [];
		for (let i in localStorage) {
			if (i.indexOf('thermosProdRecentView_') !== -1) {
				recentStorage.push(i);
			}
		}
		if (recentStorage.length > 0) {
			let recentList = [];
			let p = new Promise((resolve) => {
				let count = 0;
				recentStorage.forEach((ele, index) => {
					let recentProd = ele.replace(/thermosProdRecentView_/, '');
					getJSONseries(recentProd).then((data) => {
						if (data.product_spec_list.length) {
							let thisPN = '', thisPNHead = '';
							data.product_spec_list.forEach((ele, index) => {
								if (!thisPNHead && ele.ps_product_number.indexOf('-') !== -1) { // 先頭の文字を取る
									thisPNHead = ele.ps_product_number.split('-')[0];
								}
								let addText;
								if (index === 0) {
									addText = ele.ps_product_number + '・';
								} else {
									addText = ele.ps_product_number.replace(`${thisPNHead}-`, '') + '・';
								}
								thisPN += addText;

								if (addText.indexOf('-') !== -1) { // 先頭文字が二つ以上の場合入れ替え（順番に書かれている前提）
									thisPNHead = ele.ps_product_number.split('-')[0];
								}
							});
							thisPN = thisPN.slice(0, -1);

							recentList.push({
								datetime: localStorage[ele],
								pn: recentProd,
								pndisp: thisPN
							});
							++count;

							if (count === recentStorage.length) {
								return resolve(recentList);
							}
						} else {
							localStorage.removeItem('thermosProdRecentView_' + recentProd);
							++count;
						}
					});
				});
			});
			Promise.all([p]).then(() => {
				recentList.sort((x, y) => {
					let xDate = x['datetime'];
					let yDate = y['datetime'];
					if (xDate > yDate) return -1;
					if (xDate < yDate) return 1;
					return 0;
				});
				if (recentList.length > 5) {
					localStorage.removeItem('thermosProdRecentView_' + recentList[5].pn);
					recentList.pop();
				}

				let recentHTML = '';
				for (let l = 0; l < recentList.length; l++) {
					recentHTML += '<div class="__item">';
					recentHTML += THERMOS.va.isEnglish ? `<a href="/english/product/series/${recentList[l].pn}.html" class="mod-a">` : `<a href="/product/series/${recentList[l].pn}.html" class="mod-a">`;
					recentHTML += `<figure><img src="/product_file/file/s_${recentList[l].pn}.jpg" alt="${recentList[l].pndisp}"></figure><p>${recentList[l].pndisp}</p></a></div>`;
				}
				$('.prod-detail-viewedSlider').append(recentHTML);
				$('.prod-detail-viewedSlider').slick({
					infinite: false,
					speed: 600,
					autoplay: false,
					arrows: true,
					dots: false,
					slidesToShow: 5,
					prevArrow: arrowPrev,
					nextArrow: arrowNext,
					respondTo: 'slider',
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2
							}
						}
					]
				});
			});
		} else {
			$('.prod-detail-viewedSlider').closest('.prod-detail-section').remove();
		}
	};

	// JOW-00PK限定 補足2(英語)欄を空判定の対象から除外（画像のみ登録だとremoveElmEmptyがテキスト無しと誤判定し削除するため。対象品番のみ・removeElmEmptyより前に実行）
	const keepSeriesComplement2Media = () => {
		const targetSeries = ['jow-00pk']; // 対象を追加する場合はここに品番を追記
		const seriesKey = THERMOS.va.pathname.split('/').pop().replace(/\.html$/, '');
		if (!THERMOS.va.isEnglish || !targetSeries.includes(seriesKey)) { return; }

		const $section = $('.rt_cf_pse_feature_complement2').closest('.js-checkEmptyElm');
		if ($section.find('img, iframe, svg, video, picture').length) {
			$section.removeClass('js-checkEmptyElm');
		}
	};

	// 空の要素消し込み
	const removeElmEmpty = () => {
		$('.js-checkEmptyElm').each((idx, val) => {
			if (!$(val).text().replace(/\s+/g, '').length) {
				$(val).remove();
			}
		});
	}
	const removeBlockEmpty = () => {
		if ($('.js-checkEmpty').length) {
			$('.js-checkEmpty').each((idx, val) => {
				if (!$(val).text().replace(/\s+/g, '').length) {
					$(val).parents('.js-checkEmptyWrap').remove();
				}
			});
		}
	};

	// PDFサイズをバイト表記に変換
	const bytesToSize = () => {
		const $obj = $('.js-bytesToSize');
		const sizesArr = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

		if ($obj[0]) {
			$obj.each((idx, ele) => {
				let objText = $(ele).text();
				if (objText === 0) objText = 'n/a';

				let num = parseInt(Math.floor(Math.log(objText) / Math.log(1024)), 10);
				if (num === 0) objText = objText + ' ' + sizesArr[num];

				$(ele).text((objText / Math.pow(1024, num)).toFixed(1) + ' ' + sizesArr[num]);
			});
		}
	};

	// -- ▲ functions ▲ -------------------------------------------------------------------
	// ------------------------------------------------------------------------------------

	if (map === '' || map === 'index.html') {
		topMainVis();
		if (!THERMOS.va.isEnglish) { setPickup(); }
	}
	if (map === 'all.html' || map === 'new.html' || map === 'results.html' || map === 'list') {
		removeEmptyTag();
		setSeriesProdNum();
	}
	if (map === 'bottle.html' || map === 'lunchbox.html' || map === 'kitchen.html' || map === 'tumbler_mug.html' || map === 'bag.html') {
		$('.prod-mainVis-slider').slick({
			infinite: true,
			speed: 600,
			autoplay: true,
			autoplaySpeed: 4000,
			slidesToShow: 1,
			variableWidth: true,
			centerMode: true,
			arrows: false,
			dots: true,
		});
	}
	if (map === 'list') {
		bottomNavCurrent();
	}
	if (map === 'series') {
		removeEmptyTagSeries();
		setRecentlyItemStorage();
		keepSeriesComplement2Media();

		if ($('.rt_cf_pse_category_is_fryingpan').length) { removeFryingpanNote(); }

		// カラーバリエーションスライダー
		$('.prod-detail-variationSlider').slick({
			infinite: true,
			speed: 600,
			autoplay: false,
			slidesToShow: 3,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			arrows: true,
			dots: true,
			respondTo: 'slider',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});
		// 関連製品スライダー（補足2 フリーHTML欄）
		if ($('.prod-detail-relatedSlider').length) {
			$('.prod-detail-relatedSlider').slick({
				infinite: false,
				speed: 600,
				autoplay: false,
				slidesToShow: 4,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				arrows: true,
				dots: false,
				respondTo: 'slider',
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2
						}
					}
				]
			});
		}
	}
	if (map === 'detail') {
		setSeriesTab();
		setSeriesTags();
		changeColor();
	}
	if (map === 'series' || map === 'detail') {
		removeEmptyIcon();
		removeElmEmpty();
		removeBlockEmpty();
		setRecentlyViewItem();
		bytesToSize();
	}


})(window.jQuery, window.THERMOS);
